import { Link, useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Constants from "../utils/constants";
import { useForm } from "../utils/hooks";
import WithLoginLayout from "../hocs/layouts/LoginLayout";
import { resetPass, validateGuidPass } from "../services/user";
import Reaptcha from "reaptcha";
import { useGlobalStore } from "../utils/global";

const ResetPassword = () => {
  const { showNotification } = useGlobalStore();
  var captchaRef;

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [guid, setGuid] = useState<string | null>(null);
  const [succeed, setSucceed] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [confirmNewPasswordShown, setConfirmNewPasswordShown] = useState(false);
  const [formState, setFormError, changeHandler, reset] = useForm({
    newPass: "",
    confirmNewPass: "",
    captcha: false,
  });

  useEffect(() => {
    captchaRef?.reset();

    const guid: string | null = searchParams.get("guid");

    if (guid) {
      setGuid(guid);

      validateGuidPass(guid).then((res) => {
        if (res) {
          if (!res.data.successed) {
            setError(res.data.message[0].message);
          }
        }
      });
    } else {
      navigate(Constants.APPURLS.NOT_FOUND);
    }
  }, []);

  function disableButton() {
    return (
      !formState.data.newPass ||
      !formState.data.confirmNewPass ||
      formState.data.newPass !== formState.data.confirmNewPass ||
      !formState.data.captcha
    );
  }

  function submitForm() {
    resetPass(formState.data.newPass, guid!).then((res) => {
      if (res) {
        setSucceed(res.data.message[0].message);
      }
    });

    changeHandler("captcha", false)();
    captchaRef?.reset();
  }

  function onVerify(recaptchaResponse) {
    changeHandler("captcha", true)();
  }

  return (
    <>
      {succeed.length === 0 && error.length === 0 && (
        <>
          <Link
            to={Constants.APPURLS.LOGIN}
            className="btn btn-secondary btn-medium"
          >
            <i className="icon icon-arrow-leftv-short right"></i>Oficina virtual
          </Link>

          <div className="block pt-6 md:pt-14 pb-10">
            <h1 className="text-primary-100 font-bold mb-2">
              Resetear Contraseña
            </h1>
            <p className="text-gray-70 text-body-1 font-body font-normal">
              Antes de continuar favor de{" "}
              <span className="font-semibold">
                ingresar su nueva contraseña
              </span>
            </p>
          </div>
          <form
            className="block space-y-8"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className="form-group">
              <label>Nueva Contraseña</label>
              <div className="form-icon">
                <i
                  onClick={() => setNewPasswordShown(!newPasswordShown)}
                  className={`icon icon-eye${
                    newPasswordShown ? "" : "off"
                  } right text-gray-80 icon-password text-[10px]`}
                ></i>
                <input
                  type={newPasswordShown ? "text" : "password"}
                  className="form-control large"
                  placeholder="Ingresa tu nueva contraseña"
                  value={formState.data.newPass}
                  onChange={changeHandler("newPass")}
                />
              </div>
              <small>Debe tener al menos 8 caracteres</small>
            </div>
            <div className="form-group">
              <label>Confirmación de Contraseña</label>
              <div className="form-icon">
                <i
                  onClick={() =>
                    setConfirmNewPasswordShown(!confirmNewPasswordShown)
                  }
                  className={`icon icon-eye${
                    confirmNewPasswordShown ? "" : "off"
                  } right text-gray-80 icon-password text-[10px]`}
                ></i>
                <input
                  type={confirmNewPasswordShown ? "text" : "password"}
                  className="form-control large"
                  placeholder="Confirma tu nueva contraseña"
                  value={formState.data.confirmNewPass}
                  onChange={changeHandler("confirmNewPass")}
                />
              </div>
              <small>Ambas contraseñas deben de ser iguales</small>
            </div>
            <Reaptcha
              ref={(e) => (captchaRef = e)}
              sitekey={process.env.REACT_APP_SITE_KEY}
              onVerify={onVerify}
            />
            <button
              type="button"
              onClick={submitForm}
              disabled={disableButton()}
              className="btn btn-primary btn-large w-full"
            >
              Continuar
            </button>
          </form>
        </>
      )}
      {succeed.length > 0 && (
        <div className="block text-center">
          <div className="w-20 h-20 rounded-full border-2 border-primary-90 p-2 mx-auto mb-10">
            <i className="icon icon-check  rounded-full bg-primary-20 text-primary-100 text-[20px] w-full h-full flex items-center justify-center"></i>
          </div>
          <h1 className="text-primary-100 font-bold mb-2">Solicitud Enviada</h1>
          <p className="text-gray-70 text-body-1 font-body font-normal mb-12">
            {succeed}
          </p>
          <Link
            to={Constants.APPURLS.LOGIN}
            className="btn btn-primary btn-large px-4 md:px-[112px]"
          >
            Ir a Inicio de Sesión
          </Link>
        </div>
      )}
      {error.length > 0 && (
        <div className="block text-center">
          <div className="w-20 h-20 rounded-full border-2 border-primary-90 p-2 mx-auto mb-10">
            <i className="icon icon-check  rounded-full bg-primary-20 text-primary-100 text-[20px] w-full h-full flex items-center justify-center"></i>
          </div>
          <h1 className="text-primary-100 font-bold mb-2">Enlace erróneo</h1>
          <p className="text-gray-70 text-body-1 font-body font-normal mb-12">
            {error}
          </p>
          <Link
            to={Constants.APPURLS.LOGIN}
            className="btn btn-primary btn-large px-4 md:px-[112px]"
          >
            Ir a Inicio de Sesión
          </Link>
        </div>
      )}
    </>
  );
};

export default WithLoginLayout(ResetPassword);
